const FUNCTIONS_BASE = import.meta.env.VITE_FUNCTIONS_BASE as string;

export interface CommunityFeedItem {
  id: string;
  imageUrl: string;
  productPageUrl: string;
  garmentImageUrl: string;
  createdAt: number;
}

/**
 * Fetch the community feed (recent shared try-on generations).
 */
export async function fetchCommunityFeed(limit = 30): Promise<CommunityFeedItem[]> {
  const res = await fetch(`${FUNCTIONS_BASE}/getCommunityFeed?limit=${limit}`, { method: 'GET' });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `Request failed (${res.status})`);
  if (!Array.isArray(data.items)) return [];
  return data.items.filter(
    (item: unknown): item is CommunityFeedItem =>
      typeof item === 'object' &&
      item !== null &&
      typeof (item as CommunityFeedItem).id === 'string' &&
      typeof (item as CommunityFeedItem).imageUrl === 'string' &&
      typeof (item as CommunityFeedItem).createdAt === 'number'
  );
}
